import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import styles from './styles.js';

import Translatable from '../../../../../components/Translatable';
import CardSlider from '../../CardSlider';
import Pagination from './Pagination';

import { fetchActions } from '../../../actions';

class SearchResults extends Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        contentLoading: PropTypes.bool.isRequired,
        handlePageClick: PropTypes.func.isRequired,
        initialContentLoaded: PropTypes.bool.isRequired,
        lang: PropTypes.object.isRequired,
        searchResults: PropTypes.object,
        trackingCookieId: PropTypes.number.isRequired,
        user: PropTypes.object,
        userLang: PropTypes.string.isRequired
    }

    handlePageClick = (location, tag, params) => {
        const { apiUrl, handlePageClick, trackingCookieId, userLang } = this.props;
        handlePageClick(apiUrl, userLang, location, tag, params, trackingCookieId);
    }

    render() {
        const { handlePageClick } = this;
        const {
            contentLoading,
            lang,
            searchResults,
            user
        } = this.props;
        const showAllPages = (user.isLoggedIn && user.isAdmin && user.adminModeId === 1);
        return (
            <div
                className={css(styles.searchResults)}
                aria-live="polite"
            >
                <div className={css(styles.container)}>
                    <div className={css(styles.innerContainer)}>
                        <div className={css(styles.sectionContainer)}>
                            <div className={css(styles.sectionInnerContainer)}>
                                <CardSlider
                                    cardType="normal"
                                    contentLoading={contentLoading}
                                    containerClass="responsiveColumn_search"
                                    sliderDisabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    this.props.initialContentLoaded && (searchResults && searchResults.data.length) ?
                        <Pagination
                            currentPage={searchResults.current_page}
                            handlePageClick={handlePageClick}
                            lang={lang}
                            roomCount={searchResults.total}
                            resultsFrom={searchResults.from}
                            resultsTo={searchResults.to}
                            showAllPages={showAllPages}
                            totalPages={searchResults.last_page}
                        /> :
                        <div className="col-xs-12">
                            <h5>
                                <Translatable
                                    content={{
                                        transKey: 'search.no_results'
                                    }}
                                />
                            </h5>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    apiUrl: state.config.apiUrl,
    initialContentLoaded: state.initialContentLoaded,
    lang: state.lang,
    searchResults: state.searchResults,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang
});

const mapDispatchToProps = dispatch => {
    return {
        handlePageClick: (apiUrl, userLang, location, tag, params, trackingCookieId) =>
            dispatch(fetchActions.fetchSearchResults(apiUrl, userLang, location, tag, params, trackingCookieId, true, false, true))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/SearchResults/SearchResults.jsx